import { REST_ROUTES } from '@cdw-ae/routes-shared-api';
import { ROUTE_PARAMS } from '../route-params';

/**
 * Roles controller route constants
 *
 * Maps to @Controller('roles')
 */
export const ROLES_ROUTES = {
  // Standard REST routes
  ROOT: REST_ROUTES.ROOT,
  GET_BY_ID: REST_ROUTES.GET_BY_ID,

  // Nested resource routes
  ASSIGN_PERMISSIONS: `${ROUTE_PARAMS.ID}/permissions`,
  CAN_DELETE: `${ROUTE_PARAMS.ID}/can-delete`,

} as const;

/**
 * Type representing all possible role routes
 */
export type RolesRoute = (typeof ROLES_ROUTES)[keyof typeof ROLES_ROUTES];
